import { ComponentMessageTheme, variants } from '../ComponentMessageStyles.css';
import { baseTheme } from './ComponentMessageBaseTheme.css';
import { multiVariantStyles } from './ComponentMessageVariants.css';

/*******************
 * Component Theme
 *******************/

const ComponentMessageRedwoodTheme: ComponentMessageTheme = {
  baseTheme,
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { ComponentMessageRedwoodTheme };
